// extracted by mini-css-extract-plugin
export default {"img":"agencymarketing_img__Lots7","card_button":"agencymarketing_card_button__AaghO"};